module.exports = __webpack_public_path__ + "img/tn-timeline-main-11.8595bda7.jpg";